import React from "react";
import { Link } from "react-router-dom";
import "../styles/footer.css";

export default function Footer() {
  return (
    <>
      <div className="footer">
        <div className="main-footer">
          <div className="container">
            <div className="row " style={{ padding: "20px 50px" }}>
              <div className="footer-item col-lg-4 col-sm-12">
                <h4>About</h4>
                <p>
                  METAK Healthcare India Pvt. Ltd. is established to be the Healthcare Company which focuses on Quality Aids to enable people to lead
                  a healthy, painless, energetic, life and wish them a speedy recovery...
                  <Link to="/about-us" style={{ color: "#fff" }}>
                    Read More
                  </Link>
                </p>
              </div>
              <div className="footer-item offset col-lg-3 col-sm-12">
                <h4>Useful Links</h4>
                <ul>
                  <li>
                    <p className="footer-about-info">
                      <Link to="/">Home</Link>
                    </p>
                  </li>
                  <li>
                    <p className="footer-about-info">
                      <Link to="/about-us">About Us</Link>
                    </p>
                  </li>
                  <li>
                    <p className="footer-about-info">
                      <Link to="/contact-us">Contact</Link>
                    </p>
                  </li>
                  <li>
                    <p className="footer-about-info">
                      <Link to="/enquiry">Enquiry</Link>
                    </p>
                  </li>
                </ul>
              </div>
              <div className="footer-item col-lg-4 col-sm-12">
                <h4>Address</h4>
                <ul>
                  <li>
                    <p className="footer-about-info">
                      <iconify-icon class="big-icon" icon="ion:home" />
                      C-6/9, Near C Block Market, Vasant Vihar, New Delhi - 110057
                    </p>
                  </li>
                  <li>
                    <p className="footer-about-info">
                      <Link
                        to="#"
                        onClick={(e) => {
                          window.location.href = "mailto:info@metakindia.com";
                          e.preventDefault();
                        }}
                      >
                        <iconify-icon class="big-icon" icon="fluent:mail-16-filled" /> info@metakindia.com
                      </Link>
                    </p>
                  </li>
                  <li>
                    <p className="footer-about-info">
                      <iconify-icon class="big-icon" icon="bi:telephone-fill" /> +91-9312929895, +91-8447214545
                    </p>
                  </li>
                  <li>
                    <p className="footer-about-info">
                      <iconify-icon class="big-icon" icon="bi:telephone-fill" /> +91146560397
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="sub-footer">
          <div className="container">
            <p>
              @ 2018 All Right Reserved By{" "}
              <span style={{ color: "#005598" }}>
                <strong>Metak india</strong>
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
